import React from "react";
import ReactMarkdown from "react-markdown";
import privacyPolicyContent from "./TermsOfService.md";
import "./index.css";

const TermsOfService = () => {
  const [markdownContent, setMarkdownContent] = React.useState("");

  React.useEffect(() => {
    fetch(privacyPolicyContent)
      .then((response) => response.text())
      .then((text) => setMarkdownContent(text));
  }, []);

  return (
    <div className="privacy-policy-container">
      <ReactMarkdown>{markdownContent}</ReactMarkdown>
    </div>
  );
};

export default TermsOfService;
